
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/payment-gateways",
      function () {
        return require("private-next-pages/profile/payment-gateways/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/payment-gateways"])
      });
    }
  